import React from "react";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Employer from "../../../../apiResources/Employer";
import SettingsLayout from "../../../layouts/SettingsLayout";
import SettingsHeading from "../../../settings/SettingsHeading";
import Loader from "../../../library/Loader";
import BannerImageSettingsOption from "../../../settings/BannerImageSettingsOption";

const Domains = (props: Props) => {
  const { user, company } = props;

  if (!user || !company) {
    return (
      <SettingsLayout>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Images</SettingsHeading>

      <p>The recommended image size for the profile banners is 1100 x 500 px</p>

      <BannerImageSettingsOption
        user={user}
        company={company}
        label="Banner Image 1"
        field="employerProfileImage"
      />
      <BannerImageSettingsOption
        user={user}
        company={company}
        label="Banner Image 2"
        field="employerProfileImage2"
      />
      <BannerImageSettingsOption
        user={user}
        company={company}
        label="Banner Image 3"
        field="employerProfileImage3"
      />
    </SettingsLayout>
  );
};

type Props = {
  user: EmployerUser;
  company: Employer;
};

export default Domains;
